export default {
  'analysis.test': '工专路 {no} 号店',
  'analysis.introduce': '指标说明',
  'analysis.total-sales': '总销售额',
  'analysis.day-sales': '日均销售额￥',
  'analysis.visits': '访问量',
  'analysis.visits-trend': '访问量趋势',
  'analysis.visits-ranking': '门店访问量排名',
  'analysis.day-visits': '日访问量',
  'analysis.week': '周同比',
  'analysis.day': '日同比',
  'analysis.payments': '支付笔数',
  'analysis.conversion-rate': '转化率',
  'analysis.operational-effect': '运营活动效果',
  'analysis.sales-trend': '销售趋势',
  'analysis.sales-ranking': '门店销售额排名',
  'analysis.all-year': '全年',
  'analysis.all-month': '本月',
  'analysis.all-week': '本周',
  'analysis.all-day': '今日',
  'analysis.search-users': '搜索用户数',
  'analysis.per-capita-search': '人均搜索次数',
  'analysis.online-top-search': '线上热门搜索',
  'analysis.the-proportion-of-sales': '销售额类别占比',
  'analysis.dropdown-option-one': '操作一',
  'analysis.dropdown-option-two': '操作二',
  'analysis.channel.all': '全部渠道',
  'analysis.channel.online': '线上',
  'analysis.channel.stores': '门店',
  'analysis.sales': '销售额',
  'analysis.traffic': '客流量',
  'analysis.table.rank': '排名',
  'analysis.table.search-keyword': '搜索关键词',
  'analysis.table.users': '用户数',
  'analysis.table.weekly-range': '周涨幅'
}
